import { setMapOffer } from '../../../../common/actions/setMapOffer/setMapOffer';
import { IReduxStore } from '../../../../common/types/redux';
import { getOfferByDirection } from '../../../../common/utils/ymapsModules/BalloonManager/getOfferByDirection';
import { selectActiveFeature, selectActiveOfferId } from '../../../selectors';

export function handlePinPaginationClick(
  direction: 'prev' | 'next',
  store: Pick<IReduxStore, 'getState' | 'dispatch'>,
): void {
  // Читаем выбор на каждый клик: быстрые нажатия могут прийти до следующего React-рендера.
  const state = store.getState();
  const feature = selectActiveFeature(state);
  if (!feature) {
    return;
  }

  const offer = getOfferByDirection(feature.properties.offers, selectActiveOfferId(state), direction);
  if (!offer) {
    return;
  }

  store.dispatch(setMapOffer({ realtyId: offer.realtyId, feature }));
}
